import { updateDataNode } from '@/endpoints'
import { StructureDetailDto,StructureObjectDto } from '@/endpoints/models'
import { WriteMappingData } from '@/endpoints/schemas'
import { apiCallAction, AppDispatch, UpdateDeepPartial } from '@/store/utils'
import { assignCollectionOrder } from '@/utils/collectionOrder'
import { InitDataParams } from '@/utils/structureType/useStructureTypeActions'

import { loadNodeOrHistoryVersion } from '../node/utils'
import {
	MAPPING_WRITE_INIT,
	MAPPING_WRITE_SAVE,
	MAPPING_WRITE_SELECT_TAB,
	MAPPING_WRITE_UPDATE,
} from './constants'
import { WriteMappingDataForm,WriteMappingTab } from './types'

interface InitWriteMapping {
	editMode: boolean,
	force: boolean,
	node: StructureDetailDto,
	type: typeof MAPPING_WRITE_INIT
}

interface SaveWriteMapping {
	metadata: {
		node: StructureObjectDto
	},
	payload: void
	type: typeof MAPPING_WRITE_SAVE
}

interface UpdateWriteMapping {
	node: StructureObjectDto,
	type: typeof MAPPING_WRITE_UPDATE,
	update: UpdateDeepPartial<WriteMappingDataForm>
}

interface SelectWriteMappingTab {
	node: StructureObjectDto,
	tab: WriteMappingTab,
	type: typeof MAPPING_WRITE_SELECT_TAB
}

export const initWriteMapping =
	({
		nodeId,
		editMode = false,
		force = false,
		version,
		envId,
	}: InitDataParams) =>
	async (dispatch: AppDispatch) => {
		const node = await loadNodeOrHistoryVersion(nodeId, version, envId)

		dispatch({
			type: MAPPING_WRITE_INIT,
			node,
			editMode,
			force,
		} as InitWriteMapping)
	}

export const updateWriteMapping = (
	node: StructureObjectDto,
	update: UpdateDeepPartial<WriteMappingDataForm>,
): Actions => ({
	type: MAPPING_WRITE_UPDATE,
	node,
	update,
})

export const saveWriteMapping = (node: StructureObjectDto) =>
	apiCallAction(
		(getState) => {
			const mapping = getState().writeMapping.mappings[node.id]

			if (!mapping) {
				throw new Error(`Saving unopened state ${JSON.stringify(node)}`)
			}

			const formData: WriteMappingData = {
				...mapping.form,
				columns: assignCollectionOrder(
					(mapping.form.columns || []).filter((c) => !!c.columnCode),
				),
				sourceItems: assignCollectionOrder(
					(mapping.form.sourceItems || []).filter((c) => c.id !== -1),
				),
			}

			return updateDataNode(node.id, {
				data: JSON.stringify(formData),
			})
		},
		MAPPING_WRITE_SAVE,
		{ node },
	)

export const selectWriteMappingTab = (
	node: StructureObjectDto,
	tab: WriteMappingTab,
): Actions => ({
	type: MAPPING_WRITE_SELECT_TAB,
	node,
	tab,
})

export type Actions =
	| InitWriteMapping
	| SaveWriteMapping
	| UpdateWriteMapping
	| SelectWriteMappingTab
